/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import {
  AdminHealthPage,
  AdminOverview,
  AuditEventPage,
  ClinicDetail,
  ClinicHealth,
  ClinicPage,
  ConnectionInfo,
  ConnectionTestResult,
  CreateClinicResponse,
  ErrorEvent,
  ErrorEventPage,
  ErrorSummary,
  Impersonation,
  IncidentPage,
  ProtectionSaveResult,
  ProtectionSettings,
  SecurityEventPage,
  TempPasswordResult,
  UserList,
  UserRow,
} from './model'
import type {
  AddUserRequest,
  AdminGetClinicHealthParams,
  AdminGetErrorSummaryParams,
  AdminListErrorsParams,
  AdminListHealthParams,
  AdminListIncidentsParams,
  ApiError,
  ChangeRoleRequest,
  CreateClinicRequest,
  DeactivateClinicRequest,
  EndImpersonationParams,
  ListClinicActivityParams,
  ListClinicsParams,
  ListSecurityEventsParams,
  ProtectionUpdate,
  PutConnectionRequest,
  StartImpersonationRequest,
  TestConnectionRequest,
  UpdateClinicRequest,
} from './model'

import { apiFetch } from '../../fetcher.ts'
import type { ErrorType, BodyType } from '../../fetcher.ts'
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getListClinicsUrl = (params?: ListClinicsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/v1/admin/clinics?${stringifiedParams}` : `/v1/admin/clinics`
}

/**
 * @summary Clinics with status and counts, searched and paged (S-02)
 */
export const listClinics = async (
  params?: ListClinicsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicPage> => {
  return apiFetch<ClinicPage>(getListClinicsUrl(params), {
    ...options,
    method: 'GET',

    schema: ClinicPage,
  })
}

export const getListClinicsQueryKey = (params?: ListClinicsParams) => {
  return [`/v1/admin/clinics`, ...(params ? [params] : [])] as const
}

export const getListClinicsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClinics>>,
  TError = ErrorType<ApiError>,
>(
  params?: ListClinicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinics>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListClinicsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClinics>>> = ({ signal }) =>
    listClinics(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClinics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListClinicsQueryResult = NonNullable<Awaited<ReturnType<typeof listClinics>>>
export type ListClinicsQueryError = ErrorType<ApiError>

export function useListClinics<TData = Awaited<ReturnType<typeof listClinics>>, TError = ErrorType<ApiError>>(
  params: undefined | ListClinicsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinics>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinics>>,
          TError,
          Awaited<ReturnType<typeof listClinics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinics<TData = Awaited<ReturnType<typeof listClinics>>, TError = ErrorType<ApiError>>(
  params?: ListClinicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinics>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinics>>,
          TError,
          Awaited<ReturnType<typeof listClinics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinics<TData = Awaited<ReturnType<typeof listClinics>>, TError = ErrorType<ApiError>>(
  params?: ListClinicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinics>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Clinics with status and counts, searched and paged (S-02)
 */

export function useListClinics<TData = Awaited<ReturnType<typeof listClinics>>, TError = ErrorType<ApiError>>(
  params?: ListClinicsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinics>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListClinicsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getCreateClinicUrl = () => {
  return `/v1/admin/clinics`
}

/**
 * @summary Create a clinic and its first Clinic Admin, with an optional tested connection (S-03)
 */
export const createClinic = async (
  createClinicRequest?: CreateClinicRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<CreateClinicResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<CreateClinicResponse>(getCreateClinicUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createClinicRequest),
    schema: CreateClinicResponse,
  })
}

export const getCreateClinicMutationKey = () => ['createClinic'] as const

export const getCreateClinicMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClinic>>,
    TError,
    CreateClinicMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof createClinic>>, TError, CreateClinicMutationVariables, TContext> => {
  const mutationKey = getCreateClinicMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClinic>>, CreateClinicMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {}

    return createClinic(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateClinicMutationResult = NonNullable<Awaited<ReturnType<typeof createClinic>>>
export type CreateClinicMutationBody = BodyType<CreateClinicRequest> | undefined
export type CreateClinicMutationError = ErrorType<ApiError>
export type CreateClinicMutationVariables = { data?: BodyType<CreateClinicRequest> }

/**
 * @summary Create a clinic and its first Clinic Admin, with an optional tested connection (S-03)
 */
export const useCreateClinic = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClinic>>,
      TError,
      CreateClinicMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createClinic>>, TError, CreateClinicMutationVariables, TContext> => {
  return useMutation(getCreateClinicMutationOptions(options), queryClient)
}

export const getGetClinicUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}`
}

/**
 * @summary Clinic detail and setup checklist (S-04 header, Summary)
 */
export const getClinic = async (clinicId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ClinicDetail> => {
  return apiFetch<ClinicDetail>(getGetClinicUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ClinicDetail,
  })
}

export const getGetClinicQueryKey = (clinicId: string) => {
  return [`/v1/admin/clinics/${clinicId}`] as const
}

export const getGetClinicQueryOptions = <TData = Awaited<ReturnType<typeof getClinic>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetClinicQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinic>>> = ({ signal }) =>
    getClinic(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetClinicQueryResult = NonNullable<Awaited<ReturnType<typeof getClinic>>>
export type GetClinicQueryError = ErrorType<ApiError>

export function useGetClinic<TData = Awaited<ReturnType<typeof getClinic>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getClinic>>, TError, Awaited<ReturnType<typeof getClinic>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClinic<TData = Awaited<ReturnType<typeof getClinic>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinic>>,
          TError,
          Awaited<ReturnType<typeof getClinic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClinic<TData = Awaited<ReturnType<typeof getClinic>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Clinic detail and setup checklist (S-04 header, Summary)
 */

export function useGetClinic<TData = Awaited<ReturnType<typeof getClinic>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinic>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClinicQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getUpdateClinicUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}`
}

/**
 * @summary Edit the name, time zone, testing switch, PF message switch or automatic PF security codes; the slug never changes (S-04)
 */
export const updateClinic = async (
  clinicId: string,
  updateClinicRequest?: UpdateClinicRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicDetail> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ClinicDetail>(getUpdateClinicUrl(clinicId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateClinicRequest),
    schema: ClinicDetail,
  })
}

export const getUpdateClinicMutationKey = () => ['updateClinic'] as const

export const getUpdateClinicMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClinic>>,
    TError,
    UpdateClinicMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof updateClinic>>, TError, UpdateClinicMutationVariables, TContext> => {
  const mutationKey = getUpdateClinicMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClinic>>, UpdateClinicMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return updateClinic(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateClinicMutationResult = NonNullable<Awaited<ReturnType<typeof updateClinic>>>
export type UpdateClinicMutationBody = BodyType<UpdateClinicRequest> | undefined
export type UpdateClinicMutationError = ErrorType<ApiError>
export type UpdateClinicMutationVariables = { clinicId: string; data?: BodyType<UpdateClinicRequest> }

/**
 * @summary Edit the name, time zone, testing switch, PF message switch or automatic PF security codes; the slug never changes (S-04)
 */
export const useUpdateClinic = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClinic>>,
      TError,
      UpdateClinicMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof updateClinic>>, TError, UpdateClinicMutationVariables, TContext> => {
  return useMutation(getUpdateClinicMutationOptions(options), queryClient)
}

export const getListClinicActivityUrl = (clinicId: string, params?: ListClinicActivityParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/admin/clinics/${clinicId}/activity?${stringifiedParams}`
    : `/v1/admin/clinics/${clinicId}/activity`
}

/**
 * @summary The clinic's audit events, newest first, by person, action and date (S-04 Activity)
 */
export const listClinicActivity = async (
  clinicId: string,
  params?: ListClinicActivityParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AuditEventPage> => {
  return apiFetch<AuditEventPage>(getListClinicActivityUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: AuditEventPage,
  })
}

export const getListClinicActivityQueryKey = (clinicId: string, params?: ListClinicActivityParams) => {
  return [`/v1/admin/clinics/${clinicId}/activity`, ...(params ? [params] : [])] as const
}

export const getListClinicActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof listClinicActivity>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListClinicActivityQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClinicActivity>>> = ({ signal }) =>
    listClinicActivity(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListClinicActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listClinicActivity>>>
export type ListClinicActivityQueryError = ErrorType<ApiError>

export function useListClinicActivity<
  TData = Awaited<ReturnType<typeof listClinicActivity>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: undefined | ListClinicActivityParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicActivity>>,
          TError,
          Awaited<ReturnType<typeof listClinicActivity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinicActivity<
  TData = Awaited<ReturnType<typeof listClinicActivity>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicActivity>>,
          TError,
          Awaited<ReturnType<typeof listClinicActivity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinicActivity<
  TData = Awaited<ReturnType<typeof listClinicActivity>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The clinic's audit events, newest first, by person, action and date (S-04 Activity)
 */

export function useListClinicActivity<
  TData = Awaited<ReturnType<typeof listClinicActivity>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicActivity>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListClinicActivityQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetConnectionUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/connection`
}

/**
 * @summary PF Keeper address, masked key and last test (S-04 Connection)
 */
export const getConnection = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ConnectionInfo> => {
  return apiFetch<ConnectionInfo>(getGetConnectionUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ConnectionInfo,
  })
}

export const getGetConnectionQueryKey = (clinicId: string) => {
  return [`/v1/admin/clinics/${clinicId}/connection`] as const
}

export const getGetConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetConnectionQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnection>>> = ({ signal }) =>
    getConnection(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getConnection>>>
export type GetConnectionQueryError = ErrorType<ApiError>

export function useGetConnection<TData = Awaited<ReturnType<typeof getConnection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnection>>,
          TError,
          Awaited<ReturnType<typeof getConnection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnection<TData = Awaited<ReturnType<typeof getConnection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnection>>,
          TError,
          Awaited<ReturnType<typeof getConnection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnection<TData = Awaited<ReturnType<typeof getConnection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary PF Keeper address, masked key and last test (S-04 Connection)
 */

export function useGetConnection<TData = Awaited<ReturnType<typeof getConnection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConnectionQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutConnectionUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/connection`
}

/**
 * @summary Set the PF Keeper address and/or replace the API key (S-04 Connection)
 */
export const putConnection = async (
  clinicId: string,
  putConnectionRequest?: PutConnectionRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ConnectionInfo> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ConnectionInfo>(getPutConnectionUrl(clinicId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putConnectionRequest),
    schema: ConnectionInfo,
  })
}

export const getPutConnectionMutationKey = () => ['putConnection'] as const

export const getPutConnectionMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putConnection>>,
    TError,
    PutConnectionMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof putConnection>>, TError, PutConnectionMutationVariables, TContext> => {
  const mutationKey = getPutConnectionMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putConnection>>, PutConnectionMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return putConnection(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof putConnection>>>
export type PutConnectionMutationBody = BodyType<PutConnectionRequest> | undefined
export type PutConnectionMutationError = ErrorType<ApiError>
export type PutConnectionMutationVariables = { clinicId: string; data?: BodyType<PutConnectionRequest> }

/**
 * @summary Set the PF Keeper address and/or replace the API key (S-04 Connection)
 */
export const usePutConnection = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putConnection>>,
      TError,
      PutConnectionMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof putConnection>>, TError, PutConnectionMutationVariables, TContext> => {
  return useMutation(getPutConnectionMutationOptions(options), queryClient)
}

export const getTestConnectionUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/connection/test`
}

/**
 * @summary Probe PF Keeper with the saved or proposed values; the result is in the body (S-04, S-03)
 */
export const testConnection = async (
  clinicId: string,
  testConnectionRequest?: TestConnectionRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ConnectionTestResult> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ConnectionTestResult>(getTestConnectionUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testConnectionRequest),
    schema: ConnectionTestResult,
  })
}

export const getTestConnectionMutationKey = () => ['testConnection'] as const

export const getTestConnectionMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testConnection>>,
    TError,
    TestConnectionMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof testConnection>>,
  TError,
  TestConnectionMutationVariables,
  TContext
> => {
  const mutationKey = getTestConnectionMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof testConnection>>, TestConnectionMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return testConnection(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type TestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof testConnection>>>
export type TestConnectionMutationBody = BodyType<TestConnectionRequest> | undefined
export type TestConnectionMutationError = ErrorType<ApiError>
export type TestConnectionMutationVariables = { clinicId: string; data?: BodyType<TestConnectionRequest> }

/**
 * @summary Probe PF Keeper with the saved or proposed values; the result is in the body (S-04, S-03)
 */
export const useTestConnection = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testConnection>>,
      TError,
      TestConnectionMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof testConnection>>, TError, TestConnectionMutationVariables, TContext> => {
  return useMutation(getTestConnectionMutationOptions(options), queryClient)
}

export const getDeactivateClinicUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/deactivate`
}

/**
 * @summary Deactivate: patients see P-17, clinic sign-in is refused, holds are released; idempotent (S-04)
 */
export const deactivateClinic = async (
  clinicId: string,
  deactivateClinicRequest?: DeactivateClinicRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicDetail> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ClinicDetail>(getDeactivateClinicUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deactivateClinicRequest),
    schema: ClinicDetail,
  })
}

export const getDeactivateClinicMutationKey = () => ['deactivateClinic'] as const

export const getDeactivateClinicMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateClinic>>,
    TError,
    DeactivateClinicMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateClinic>>,
  TError,
  DeactivateClinicMutationVariables,
  TContext
> => {
  const mutationKey = getDeactivateClinicMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateClinic>>,
    DeactivateClinicMutationVariables
  > = (props) => {
    const { clinicId, data } = props ?? {}

    return deactivateClinic(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeactivateClinicMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateClinic>>>
export type DeactivateClinicMutationBody = BodyType<DeactivateClinicRequest> | undefined
export type DeactivateClinicMutationError = ErrorType<ApiError>
export type DeactivateClinicMutationVariables = { clinicId: string; data?: BodyType<DeactivateClinicRequest> }

/**
 * @summary Deactivate: patients see P-17, clinic sign-in is refused, holds are released; idempotent (S-04)
 */
export const useDeactivateClinic = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateClinic>>,
      TError,
      DeactivateClinicMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateClinic>>,
  TError,
  DeactivateClinicMutationVariables,
  TContext
> => {
  return useMutation(getDeactivateClinicMutationOptions(options), queryClient)
}

export const getAdminGetClinicHealthUrl = (clinicId: string, params?: AdminGetClinicHealthParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/admin/clinics/${clinicId}/health?${stringifiedParams}`
    : `/v1/admin/clinics/${clinicId}/health`
}

/**
 * @summary The C-12 content for one clinic (S-04 Health)
 */
export const adminGetClinicHealth = async (
  clinicId: string,
  params?: AdminGetClinicHealthParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicHealth> => {
  return apiFetch<ClinicHealth>(getAdminGetClinicHealthUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: ClinicHealth,
  })
}

export const getAdminGetClinicHealthQueryKey = (clinicId: string, params?: AdminGetClinicHealthParams) => {
  return [`/v1/admin/clinics/${clinicId}/health`, ...(params ? [params] : [])] as const
}

export const getAdminGetClinicHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: AdminGetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetClinicHealthQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetClinicHealth>>> = ({ signal }) =>
    adminGetClinicHealth(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type AdminGetClinicHealthQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetClinicHealth>>>
export type AdminGetClinicHealthQueryError = ErrorType<ApiError>

export function useAdminGetClinicHealth<
  TData = Awaited<ReturnType<typeof adminGetClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: undefined | AdminGetClinicHealthParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetClinicHealth>>,
          TError,
          Awaited<ReturnType<typeof adminGetClinicHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetClinicHealth<
  TData = Awaited<ReturnType<typeof adminGetClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: AdminGetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetClinicHealth>>,
          TError,
          Awaited<ReturnType<typeof adminGetClinicHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetClinicHealth<
  TData = Awaited<ReturnType<typeof adminGetClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: AdminGetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The C-12 content for one clinic (S-04 Health)
 */

export function useAdminGetClinicHealth<
  TData = Awaited<ReturnType<typeof adminGetClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: AdminGetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetClinicHealthQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getStartImpersonationUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/impersonations`
}

/**
 * @summary Act as clinic admin for 60 minutes; ends your other open session (S-06 Continue)
 */
export const startImpersonation = async (
  clinicId: string,
  startImpersonationRequest?: StartImpersonationRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<Impersonation> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<Impersonation>(getStartImpersonationUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startImpersonationRequest),
    schema: Impersonation,
  })
}

export const getStartImpersonationMutationKey = () => ['startImpersonation'] as const

export const getStartImpersonationMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startImpersonation>>,
    TError,
    StartImpersonationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof startImpersonation>>,
  TError,
  StartImpersonationMutationVariables,
  TContext
> => {
  const mutationKey = getStartImpersonationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startImpersonation>>,
    StartImpersonationMutationVariables
  > = (props) => {
    const { clinicId, data } = props ?? {}

    return startImpersonation(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type StartImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof startImpersonation>>>
export type StartImpersonationMutationBody = BodyType<StartImpersonationRequest> | undefined
export type StartImpersonationMutationError = ErrorType<ApiError>
export type StartImpersonationMutationVariables = { clinicId: string; data?: BodyType<StartImpersonationRequest> }

/**
 * @summary Act as clinic admin for 60 minutes; ends your other open session (S-06 Continue)
 */
export const useStartImpersonation = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startImpersonation>>,
      TError,
      StartImpersonationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startImpersonation>>,
  TError,
  StartImpersonationMutationVariables,
  TContext
> => {
  return useMutation(getStartImpersonationMutationOptions(options), queryClient)
}

export const getGetProtectionUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/protection`
}

/**
 * @summary The clinic's protection settings: effective, overrides and defaults (S-04 Protection)
 */
export const getProtection = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ProtectionSettings> => {
  return apiFetch<ProtectionSettings>(getGetProtectionUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ProtectionSettings,
  })
}

export const getGetProtectionQueryKey = (clinicId: string) => {
  return [`/v1/admin/clinics/${clinicId}/protection`] as const
}

export const getGetProtectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getProtection>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProtectionQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProtection>>> = ({ signal }) =>
    getProtection(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetProtectionQueryResult = NonNullable<Awaited<ReturnType<typeof getProtection>>>
export type GetProtectionQueryError = ErrorType<ApiError>

export function useGetProtection<TData = Awaited<ReturnType<typeof getProtection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProtection>>,
          TError,
          Awaited<ReturnType<typeof getProtection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProtection<TData = Awaited<ReturnType<typeof getProtection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProtection>>,
          TError,
          Awaited<ReturnType<typeof getProtection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProtection<TData = Awaited<ReturnType<typeof getProtection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The clinic's protection settings: effective, overrides and defaults (S-04 Protection)
 */

export function useGetProtection<TData = Awaited<ReturnType<typeof getProtection>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProtection>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProtectionQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutProtectionUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/protection`
}

/**
 * @summary Replace the S-04 protection overrides; last write wins (S-04 Protection Save / Reset to defaults)
 */
export const putProtection = async (
  clinicId: string,
  protectionUpdate?: ProtectionUpdate,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ProtectionSaveResult> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ProtectionSaveResult>(getPutProtectionUrl(clinicId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(protectionUpdate),
    schema: ProtectionSaveResult,
  })
}

export const getPutProtectionMutationKey = () => ['putProtection'] as const

export const getPutProtectionMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putProtection>>,
    TError,
    PutProtectionMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof putProtection>>, TError, PutProtectionMutationVariables, TContext> => {
  const mutationKey = getPutProtectionMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProtection>>, PutProtectionMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return putProtection(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutProtectionMutationResult = NonNullable<Awaited<ReturnType<typeof putProtection>>>
export type PutProtectionMutationBody = BodyType<ProtectionUpdate> | undefined
export type PutProtectionMutationError = ErrorType<ApiError>
export type PutProtectionMutationVariables = { clinicId: string; data?: BodyType<ProtectionUpdate> }

/**
 * @summary Replace the S-04 protection overrides; last write wins (S-04 Protection Save / Reset to defaults)
 */
export const usePutProtection = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putProtection>>,
      TError,
      PutProtectionMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof putProtection>>, TError, PutProtectionMutationVariables, TContext> => {
  return useMutation(getPutProtectionMutationOptions(options), queryClient)
}

export const getReactivateClinicUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/reactivate`
}

/**
 * @summary Reactivate: reverses Deactivate; idempotent (S-04)
 */
export const reactivateClinic = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicDetail> => {
  return apiFetch<ClinicDetail>(getReactivateClinicUrl(clinicId), {
    ...options,
    method: 'POST',

    schema: ClinicDetail,
  })
}

export const getReactivateClinicMutationKey = () => ['reactivateClinic'] as const

export const getReactivateClinicMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateClinic>>,
    TError,
    ReactivateClinicMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivateClinic>>,
  TError,
  ReactivateClinicMutationVariables,
  TContext
> => {
  const mutationKey = getReactivateClinicMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivateClinic>>,
    ReactivateClinicMutationVariables
  > = (props) => {
    const { clinicId } = props ?? {}

    return reactivateClinic(clinicId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ReactivateClinicMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateClinic>>>

export type ReactivateClinicMutationError = ErrorType<ApiError>
export type ReactivateClinicMutationVariables = { clinicId: string }

/**
 * @summary Reactivate: reverses Deactivate; idempotent (S-04)
 */
export const useReactivateClinic = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reactivateClinic>>,
      TError,
      ReactivateClinicMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reactivateClinic>>,
  TError,
  ReactivateClinicMutationVariables,
  TContext
> => {
  return useMutation(getReactivateClinicMutationOptions(options), queryClient)
}

export const getListSecurityEventsUrl = (clinicId: string, params?: ListSecurityEventsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['decision']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v))
      })
      return
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/admin/clinics/${clinicId}/security-events?${stringifiedParams}`
    : `/v1/admin/clinics/${clinicId}/security-events`
}

/**
 * @summary The clinic's recent security events, newest first; never IP, user agent or hashes (S-04 Protection)
 */
export const listSecurityEvents = async (
  clinicId: string,
  params?: ListSecurityEventsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<SecurityEventPage> => {
  return apiFetch<SecurityEventPage>(getListSecurityEventsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: SecurityEventPage,
  })
}

export const getListSecurityEventsQueryKey = (clinicId: string, params?: ListSecurityEventsParams) => {
  return [`/v1/admin/clinics/${clinicId}/security-events`, ...(params ? [params] : [])] as const
}

export const getListSecurityEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSecurityEvents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListSecurityEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListSecurityEventsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSecurityEvents>>> = ({ signal }) =>
    listSecurityEvents(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListSecurityEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSecurityEvents>>>
export type ListSecurityEventsQueryError = ErrorType<ApiError>

export function useListSecurityEvents<
  TData = Awaited<ReturnType<typeof listSecurityEvents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: undefined | ListSecurityEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecurityEvents>>,
          TError,
          Awaited<ReturnType<typeof listSecurityEvents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSecurityEvents<
  TData = Awaited<ReturnType<typeof listSecurityEvents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListSecurityEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSecurityEvents>>,
          TError,
          Awaited<ReturnType<typeof listSecurityEvents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSecurityEvents<
  TData = Awaited<ReturnType<typeof listSecurityEvents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListSecurityEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The clinic's recent security events, newest first; never IP, user agent or hashes (S-04 Protection)
 */

export function useListSecurityEvents<
  TData = Awaited<ReturnType<typeof listSecurityEvents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListSecurityEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSecurityEvents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSecurityEventsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAdminListUsersUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/users`
}

/**
 * @summary The clinic's users, by name (S-04 Users)
 */
export const adminListUsers = async (clinicId: string, options?: Parameters<typeof apiFetch>[1]): Promise<UserList> => {
  return apiFetch<UserList>(getAdminListUsersUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: UserList,
  })
}

export const getAdminListUsersQueryKey = (clinicId: string) => {
  return [`/v1/admin/clinics/${clinicId}/users`] as const
}

export const getAdminListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListUsersQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUsers>>> = ({ signal }) =>
    adminListUsers(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type AdminListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminListUsers>>>
export type AdminListUsersQueryError = ErrorType<ApiError>

export function useAdminListUsers<TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUsers>>,
          TError,
          Awaited<ReturnType<typeof adminListUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListUsers<TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUsers>>,
          TError,
          Awaited<ReturnType<typeof adminListUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListUsers<TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The clinic's users, by name (S-04 Users)
 */

export function useAdminListUsers<TData = Awaited<ReturnType<typeof adminListUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListUsersQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAdminAddUserUrl = (clinicId: string) => {
  return `/v1/admin/clinics/${clinicId}/users`
}

/**
 * @summary Add a user; the temporary password is returned once (S-05 → C-13b)
 */
export const adminAddUser = async (
  clinicId: string,
  addUserRequest?: AddUserRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<TempPasswordResult> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<TempPasswordResult>(getAdminAddUserUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addUserRequest),
    schema: TempPasswordResult,
  })
}

export const getAdminAddUserMutationKey = () => ['adminAddUser'] as const

export const getAdminAddUserMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAddUser>>,
    TError,
    AdminAddUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof adminAddUser>>, TError, AdminAddUserMutationVariables, TContext> => {
  const mutationKey = getAdminAddUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAddUser>>, AdminAddUserMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return adminAddUser(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminAddUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminAddUser>>>
export type AdminAddUserMutationBody = BodyType<AddUserRequest> | undefined
export type AdminAddUserMutationError = ErrorType<ApiError>
export type AdminAddUserMutationVariables = { clinicId: string; data?: BodyType<AddUserRequest> }

/**
 * @summary Add a user; the temporary password is returned once (S-05 → C-13b)
 */
export const useAdminAddUser = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminAddUser>>,
      TError,
      AdminAddUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof adminAddUser>>, TError, AdminAddUserMutationVariables, TContext> => {
  return useMutation(getAdminAddUserMutationOptions(options), queryClient)
}

export const getAdminRemoveUserUrl = (clinicId: string, userId: string) => {
  return `/v1/admin/clinics/${clinicId}/users/${userId}`
}

/**
 * @summary Remove the membership and end the user's sessions (S-04 Users Remove)
 */
export const adminRemoveUser = async (
  clinicId: string,
  userId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  return apiFetch<void>(getAdminRemoveUserUrl(clinicId, userId), {
    ...options,
    method: 'DELETE',
  })
}

export const getAdminRemoveUserMutationKey = () => ['adminRemoveUser'] as const

export const getAdminRemoveUserMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRemoveUser>>,
    TError,
    AdminRemoveUserMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRemoveUser>>,
  TError,
  AdminRemoveUserMutationVariables,
  TContext
> => {
  const mutationKey = getAdminRemoveUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRemoveUser>>, AdminRemoveUserMutationVariables> = (
    props,
  ) => {
    const { clinicId, userId } = props ?? {}

    return adminRemoveUser(clinicId, userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminRemoveUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminRemoveUser>>>

export type AdminRemoveUserMutationError = ErrorType<ApiError>
export type AdminRemoveUserMutationVariables = { clinicId: string; userId: string }

/**
 * @summary Remove the membership and end the user's sessions (S-04 Users Remove)
 */
export const useAdminRemoveUser = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminRemoveUser>>,
      TError,
      AdminRemoveUserMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminRemoveUser>>,
  TError,
  AdminRemoveUserMutationVariables,
  TContext
> => {
  return useMutation(getAdminRemoveUserMutationOptions(options), queryClient)
}

export const getAdminChangeUserRoleUrl = (clinicId: string, userId: string) => {
  return `/v1/admin/clinics/${clinicId}/users/${userId}`
}

/**
 * @summary Change a user's role (S-04 Users Change role)
 */
export const adminChangeUserRole = async (
  clinicId: string,
  userId: string,
  changeRoleRequest?: ChangeRoleRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<UserRow> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<UserRow>(getAdminChangeUserRoleUrl(clinicId, userId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeRoleRequest),
    schema: UserRow,
  })
}

export const getAdminChangeUserRoleMutationKey = () => ['adminChangeUserRole'] as const

export const getAdminChangeUserRoleMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminChangeUserRole>>,
    TError,
    AdminChangeUserRoleMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminChangeUserRole>>,
  TError,
  AdminChangeUserRoleMutationVariables,
  TContext
> => {
  const mutationKey = getAdminChangeUserRoleMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminChangeUserRole>>,
    AdminChangeUserRoleMutationVariables
  > = (props) => {
    const { clinicId, userId, data } = props ?? {}

    return adminChangeUserRole(clinicId, userId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminChangeUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminChangeUserRole>>>
export type AdminChangeUserRoleMutationBody = BodyType<ChangeRoleRequest> | undefined
export type AdminChangeUserRoleMutationError = ErrorType<ApiError>
export type AdminChangeUserRoleMutationVariables = {
  clinicId: string
  userId: string
  data?: BodyType<ChangeRoleRequest>
}

/**
 * @summary Change a user's role (S-04 Users Change role)
 */
export const useAdminChangeUserRole = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminChangeUserRole>>,
      TError,
      AdminChangeUserRoleMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminChangeUserRole>>,
  TError,
  AdminChangeUserRoleMutationVariables,
  TContext
> => {
  return useMutation(getAdminChangeUserRoleMutationOptions(options), queryClient)
}

export const getAdminResetUserPasswordUrl = (clinicId: string, userId: string) => {
  return `/v1/admin/clinics/${clinicId}/users/${userId}/reset-password`
}

/**
 * @summary A new temporary password, shown once (S-04 Users Reset password → C-13b)
 */
export const adminResetUserPassword = async (
  clinicId: string,
  userId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<TempPasswordResult> => {
  return apiFetch<TempPasswordResult>(getAdminResetUserPasswordUrl(clinicId, userId), {
    ...options,
    method: 'POST',

    schema: TempPasswordResult,
  })
}

export const getAdminResetUserPasswordMutationKey = () => ['adminResetUserPassword'] as const

export const getAdminResetUserPasswordMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminResetUserPassword>>,
    TError,
    AdminResetUserPasswordMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminResetUserPassword>>,
  TError,
  AdminResetUserPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getAdminResetUserPasswordMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminResetUserPassword>>,
    AdminResetUserPasswordMutationVariables
  > = (props) => {
    const { clinicId, userId } = props ?? {}

    return adminResetUserPassword(clinicId, userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdminResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof adminResetUserPassword>>>

export type AdminResetUserPasswordMutationError = ErrorType<ApiError>
export type AdminResetUserPasswordMutationVariables = { clinicId: string; userId: string }

/**
 * @summary A new temporary password, shown once (S-04 Users Reset password → C-13b)
 */
export const useAdminResetUserPassword = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminResetUserPassword>>,
      TError,
      AdminResetUserPasswordMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminResetUserPassword>>,
  TError,
  AdminResetUserPasswordMutationVariables,
  TContext
> => {
  return useMutation(getAdminResetUserPasswordMutationOptions(options), queryClient)
}

export const getAdminListErrorsUrl = (params?: AdminListErrorsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/v1/admin/errors?${stringifiedParams}` : `/v1/admin/errors`
}

/**
 * @summary Error events across clinics, or one clinic with clinicId; newest first (S-08, S-04 Errors)
 */
export const adminListErrors = async (
  params?: AdminListErrorsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ErrorEventPage> => {
  return apiFetch<ErrorEventPage>(getAdminListErrorsUrl(params), {
    ...options,
    method: 'GET',

    schema: ErrorEventPage,
  })
}

export const getAdminListErrorsQueryKey = (params?: AdminListErrorsParams) => {
  return [`/v1/admin/errors`, ...(params ? [params] : [])] as const
}

export const getAdminListErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListErrors>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListErrorsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListErrors>>> = ({ signal }) =>
    adminListErrors(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListErrors>>>
export type AdminListErrorsQueryError = ErrorType<ApiError>

export function useAdminListErrors<TData = Awaited<ReturnType<typeof adminListErrors>>, TError = ErrorType<ApiError>>(
  params: undefined | AdminListErrorsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListErrors>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListErrors>>,
          TError,
          Awaited<ReturnType<typeof adminListErrors>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListErrors<TData = Awaited<ReturnType<typeof adminListErrors>>, TError = ErrorType<ApiError>>(
  params?: AdminListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListErrors>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListErrors>>,
          TError,
          Awaited<ReturnType<typeof adminListErrors>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListErrors<TData = Awaited<ReturnType<typeof adminListErrors>>, TError = ErrorType<ApiError>>(
  params?: AdminListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Error events across clinics, or one clinic with clinicId; newest first (S-08, S-04 Errors)
 */

export function useAdminListErrors<TData = Awaited<ReturnType<typeof adminListErrors>>, TError = ErrorType<ApiError>>(
  params?: AdminListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListErrorsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAdminGetErrorSummaryUrl = (params?: AdminGetErrorSummaryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/v1/admin/errors/summary?${stringifiedParams}` : `/v1/admin/errors/summary`
}

/**
 * @summary Counters and per-code counts across clinics, or one clinic with clinicId (S-08, S-04 Errors)
 */
export const adminGetErrorSummary = async (
  params?: AdminGetErrorSummaryParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ErrorSummary> => {
  return apiFetch<ErrorSummary>(getAdminGetErrorSummaryUrl(params), {
    ...options,
    method: 'GET',

    schema: ErrorSummary,
  })
}

export const getAdminGetErrorSummaryQueryKey = (params?: AdminGetErrorSummaryParams) => {
  return [`/v1/admin/errors/summary`, ...(params ? [params] : [])] as const
}

export const getAdminGetErrorSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminGetErrorSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetErrorSummaryQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetErrorSummary>>> = ({ signal }) =>
    adminGetErrorSummary(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetErrorSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetErrorSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetErrorSummary>>>
export type AdminGetErrorSummaryQueryError = ErrorType<ApiError>

export function useAdminGetErrorSummary<
  TData = Awaited<ReturnType<typeof adminGetErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  params: undefined | AdminGetErrorSummaryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrorSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetErrorSummary>>,
          TError,
          Awaited<ReturnType<typeof adminGetErrorSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetErrorSummary<
  TData = Awaited<ReturnType<typeof adminGetErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminGetErrorSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrorSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetErrorSummary>>,
          TError,
          Awaited<ReturnType<typeof adminGetErrorSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetErrorSummary<
  TData = Awaited<ReturnType<typeof adminGetErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminGetErrorSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Counters and per-code counts across clinics, or one clinic with clinicId (S-08, S-04 Errors)
 */

export function useAdminGetErrorSummary<
  TData = Awaited<ReturnType<typeof adminGetErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminGetErrorSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetErrorSummaryQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAdminGetErrorUrl = (errorId: string) => {
  return `/v1/admin/errors/${errorId}`
}

/**
 * @summary One error event with its clinic (S-08 drawer)
 */
export const adminGetError = async (errorId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ErrorEvent> => {
  return apiFetch<ErrorEvent>(getAdminGetErrorUrl(errorId), {
    ...options,
    method: 'GET',

    schema: ErrorEvent,
  })
}

export const getAdminGetErrorQueryKey = (errorId: string) => {
  return [`/v1/admin/errors/${errorId}`] as const
}

export const getAdminGetErrorQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetError>>,
  TError = ErrorType<ApiError>,
>(
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminGetErrorQueryKey(errorId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetError>>> = ({ signal }) =>
    adminGetError(errorId, { signal, ...requestOptions })

  return { queryKey, queryFn, enabled: errorId !== null && errorId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetError>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetErrorQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetError>>>
export type AdminGetErrorQueryError = ErrorType<ApiError>

export function useAdminGetError<TData = Awaited<ReturnType<typeof adminGetError>>, TError = ErrorType<ApiError>>(
  errorId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetError>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetError>>,
          TError,
          Awaited<ReturnType<typeof adminGetError>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetError<TData = Awaited<ReturnType<typeof adminGetError>>, TError = ErrorType<ApiError>>(
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetError>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetError>>,
          TError,
          Awaited<ReturnType<typeof adminGetError>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetError<TData = Awaited<ReturnType<typeof adminGetError>>, TError = ErrorType<ApiError>>(
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One error event with its clinic (S-08 drawer)
 */

export function useAdminGetError<TData = Awaited<ReturnType<typeof adminGetError>>, TError = ErrorType<ApiError>>(
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminGetErrorQueryOptions(errorId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAdminListHealthUrl = (params?: AdminListHealthParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/v1/admin/health?${stringifiedParams}` : `/v1/admin/health`
}

/**
 * @summary One row per active clinic: states, last heartbeat, overall uptime and day strip (S-07)
 */
export const adminListHealth = async (
  params?: AdminListHealthParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AdminHealthPage> => {
  return apiFetch<AdminHealthPage>(getAdminListHealthUrl(params), {
    ...options,
    method: 'GET',

    schema: AdminHealthPage,
  })
}

export const getAdminListHealthQueryKey = (params?: AdminListHealthParams) => {
  return [`/v1/admin/health`, ...(params ? [params] : [])] as const
}

export const getAdminListHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListHealth>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListHealthQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListHealth>>> = ({ signal }) =>
    adminListHealth(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListHealthQueryResult = NonNullable<Awaited<ReturnType<typeof adminListHealth>>>
export type AdminListHealthQueryError = ErrorType<ApiError>

export function useAdminListHealth<TData = Awaited<ReturnType<typeof adminListHealth>>, TError = ErrorType<ApiError>>(
  params: undefined | AdminListHealthParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHealth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListHealth>>,
          TError,
          Awaited<ReturnType<typeof adminListHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListHealth<TData = Awaited<ReturnType<typeof adminListHealth>>, TError = ErrorType<ApiError>>(
  params?: AdminListHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHealth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListHealth>>,
          TError,
          Awaited<ReturnType<typeof adminListHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListHealth<TData = Awaited<ReturnType<typeof adminListHealth>>, TError = ErrorType<ApiError>>(
  params?: AdminListHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One row per active clinic: states, last heartbeat, overall uptime and day strip (S-07)
 */

export function useAdminListHealth<TData = Awaited<ReturnType<typeof adminListHealth>>, TError = ErrorType<ApiError>>(
  params?: AdminListHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListHealthQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getEndImpersonationUrl = (impersonationId: string, params?: EndImpersonationParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/admin/impersonations/${impersonationId}?${stringifiedParams}`
    : `/v1/admin/impersonations/${impersonationId}`
}

/**
 * @summary End your impersonation from the admin app (S-04, admin sign-out); idempotent
 */
export const endImpersonation = async (
  impersonationId: string,
  params?: EndImpersonationParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  return apiFetch<void>(getEndImpersonationUrl(impersonationId, params), {
    ...options,
    method: 'DELETE',
  })
}

export const getEndImpersonationMutationKey = () => ['endImpersonation'] as const

export const getEndImpersonationMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endImpersonation>>,
    TError,
    EndImpersonationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof endImpersonation>>,
  TError,
  EndImpersonationMutationVariables,
  TContext
> => {
  const mutationKey = getEndImpersonationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endImpersonation>>,
    EndImpersonationMutationVariables
  > = (props) => {
    const { impersonationId, params } = props ?? {}

    return endImpersonation(impersonationId, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type EndImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof endImpersonation>>>

export type EndImpersonationMutationError = ErrorType<ApiError>
export type EndImpersonationMutationVariables = { impersonationId: string; params?: EndImpersonationParams }

/**
 * @summary End your impersonation from the admin app (S-04, admin sign-out); idempotent
 */
export const useEndImpersonation = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof endImpersonation>>,
      TError,
      EndImpersonationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof endImpersonation>>,
  TError,
  EndImpersonationMutationVariables,
  TContext
> => {
  return useMutation(getEndImpersonationMutationOptions(options), queryClient)
}

export const getAdminListIncidentsUrl = (params?: AdminListIncidentsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/v1/admin/incidents?${stringifiedParams}` : `/v1/admin/incidents`
}

/**
 * @summary Incidents across clinics, or one clinic with clinicId; each with its clinic (S-07, S-04 Health)
 */
export const adminListIncidents = async (
  params?: AdminListIncidentsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<IncidentPage> => {
  return apiFetch<IncidentPage>(getAdminListIncidentsUrl(params), {
    ...options,
    method: 'GET',

    schema: IncidentPage,
  })
}

export const getAdminListIncidentsQueryKey = (params?: AdminListIncidentsParams) => {
  return [`/v1/admin/incidents`, ...(params ? [params] : [])] as const
}

export const getAdminListIncidentsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListIncidents>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAdminListIncidentsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListIncidents>>> = ({ signal }) =>
    adminListIncidents(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListIncidents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListIncidents>>>
export type AdminListIncidentsQueryError = ErrorType<ApiError>

export function useAdminListIncidents<
  TData = Awaited<ReturnType<typeof adminListIncidents>>,
  TError = ErrorType<ApiError>,
>(
  params: undefined | AdminListIncidentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIncidents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListIncidents>>,
          TError,
          Awaited<ReturnType<typeof adminListIncidents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListIncidents<
  TData = Awaited<ReturnType<typeof adminListIncidents>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIncidents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListIncidents>>,
          TError,
          Awaited<ReturnType<typeof adminListIncidents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListIncidents<
  TData = Awaited<ReturnType<typeof adminListIncidents>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Incidents across clinics, or one clinic with clinicId; each with its clinic (S-07, S-04 Health)
 */

export function useAdminListIncidents<
  TData = Awaited<ReturnType<typeof adminListIncidents>>,
  TError = ErrorType<ApiError>,
>(
  params?: AdminListIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminListIncidentsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAdminOverviewUrl = () => {
  return `/v1/admin/overview`
}

/**
 * @summary Banner, platform counts, needs-attention list and recent errors across clinics (S-01)
 */
export const getAdminOverview = async (options?: Parameters<typeof apiFetch>[1]): Promise<AdminOverview> => {
  return apiFetch<AdminOverview>(getGetAdminOverviewUrl(), {
    ...options,
    method: 'GET',

    schema: AdminOverview,
  })
}

export const getGetAdminOverviewQueryKey = () => {
  return [`/v1/admin/overview`] as const
}

export const getGetAdminOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminOverview>>,
  TError = ErrorType<ApiError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>>
  request?: SecondParameter<typeof apiFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAdminOverviewQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOverview>>> = ({ signal }) =>
    getAdminOverview({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOverview>>>
export type GetAdminOverviewQueryError = ErrorType<ApiError>

export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiError>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOverview>>,
          TError,
          Awaited<ReturnType<typeof getAdminOverview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOverview>>,
          TError,
          Awaited<ReturnType<typeof getAdminOverview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Banner, platform counts, needs-attention list and recent errors across clinics (S-01)
 */

export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
